/**
 * Comparison strip — "what others give you vs what Omega gives you."
 * Pure CSS/HTML, no images. Each row is one capability.
 */

const ROWS = [
  { cap: "Probability of profit",  others: "Black-Scholes single estimate", omega: "10K-path Monte Carlo + jump-diffusion overlay" },
  { cap: "AI explainability",      others: "None — just charts",            omega: "Claude Sonnet deep-dive on every alert" },
  { cap: "Position monitoring",    others: "You stare at the screen",       omega: "Guardian: 60s autonomous watch + verdict alerts" },
  { cap: "Exit discipline",        others: "Hope, fear, manual stop",       omega: "Auto-Trim at conviction 0.70 / full close 0.85" },
  { cap: "Weekly review",          others: "Open spreadsheet, cry",         omega: "Replay digest emails Sunday 9am ET" },
  { cap: "Decision journal",       others: "Pen + paper",                   omega: "12-vector ledger replay, animated, every trade" },
  { cap: "Mobile parity",          others: "Cut-down phone app",            omega: "Full swipe-card workspace + Omega Brain live" },
];

export default function ComparisonTable() {
  return (
    <section data-testid="comparison-table" style={{
      padding: "60px 24px", maxWidth: 1100, margin: "0 auto", width: "100%", boxSizing: "border-box",
    }}>
      <div style={{ fontSize: 11, color: "#fbbf24", letterSpacing: 2, textAlign: "center", fontWeight: 700, marginBottom: 8 }}>
        OMEGA VS THE WORLD
      </div>
      <h2 style={{ fontSize: 32, fontWeight: 800, textAlign: "center", marginBottom: 32, letterSpacing: -0.6 }}>
        What other apps can't do.
      </h2>

      <div style={{
        borderRadius: 20, overflow: "hidden",
        border: "1px solid rgba(255,255,255,0.08)",
        background: "rgba(2,6,23,0.45)",
        backdropFilter: "blur(8px)",
      }}>
        {/* Header */}
        <div style={{
          display: "grid", gridTemplateColumns: "1.4fr 1.6fr 1.6fr",
          padding: "16px 20px", gap: 14,
          background: "rgba(255,255,255,0.02)",
          borderBottom: "1px solid rgba(255,255,255,0.06)",
          fontSize: 10, letterSpacing: 2, fontWeight: 700, color: "#8b949e",
        }}>
          <div>CAPABILITY</div>
          <div>OTHER PLATFORMS</div>
          <div style={{ color: "#a78bfa" }}>OMEGA ZI AI</div>
        </div>

        {ROWS.map((r, i) => (
          <div key={i} data-testid={`compare-row-${i}`} style={{
            display: "grid", gridTemplateColumns: "1.4fr 1.6fr 1.6fr",
            padding: "16px 20px", gap: 14,
            borderBottom: i === ROWS.length - 1 ? "none" : "1px solid rgba(255,255,255,0.04)",
            alignItems: "center",
            transition: "background 200ms ease",
          }}
          onMouseEnter={(ev) => { ev.currentTarget.style.background = "rgba(167,139,250,0.04)"; }}
          onMouseLeave={(ev) => { ev.currentTarget.style.background = "transparent"; }}>
            <div style={{ fontSize: 13, color: "#e6edf3", fontWeight: 700 }}>{r.cap}</div>
            <div style={{ fontSize: 13, color: "#8b949e", display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ color: "#f87171", fontSize: 14 }}>✕</span>
              <span>{r.others}</span>
            </div>
            <div style={{ fontSize: 13, color: "#e6edf3", display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ color: "#4ade80", fontSize: 14 }}>✓</span>
              <span>{r.omega}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
